// Redirects unauthenticated users to /login.
// Redirects super_admins to apps/admin per ADR-007 (super-admin portal is a
// separate deployment; role-based access on this deployment was rejected as a
// defense-in-depth violation). The redirect gates rendering before any
// tenant-scoped data fetching can fire from authenticated children.
// Usage: wrap any route element with <ProtectedRoute>.

import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth.js";
import { env } from "../lib/env.js";
import type { JSX, ReactNode } from "react";

interface Props { children: ReactNode; }

export function ProtectedRoute({ children }: Props): JSX.Element {
  const { user } = useAuth();
  const isSuperAdmin = user?.role === "super_admin";

  useEffect(() => {
    if (isSuperAdmin) window.location.replace(env.adminUrl);
  }, [isSuperAdmin]);

  if (!user) return <Navigate to="/login" replace />;
  if (isSuperAdmin) return <></>;
  return <>{children}</>;
}
